import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { Object } from 'es6-shim';
import { diff } from 'deep-object-diff';
import { IClassiDocumentali, IUser } from '../../../../commons/interfaces/user/user';

interface IUserT {
  email: string;
  piva: string;
  codice_fiscale: string;
  company_name: string;
  _id: string;
}

class UploadFatturePassiveContoller implements ng.IController {

  static $inject: string[] = [
      '$scope',
      '$rootScope',
      '$state',
      '$http',
      'configuration',
      'store',
      'jwtHelper',
      '$uibModal',
      'ArchiSmallServices',
      '$sce',
      '$filter',
      'UiSelectService'
  ];

  constructor(
      private $scope: {
        usersList: IUserT[],
        user: IUserT,
        originalUsers: IUser[],
        getUsersTypeaheadValues: () => void,
        filtroScadenza: string[],
        dati: {xml: {file: string, name: string}, metadati: {file: string, name: string}}[],
        readFile: (file: File) => Promise<string>,
        addFile: () => void,
        removeFile: (index: number) => void,
        canRemove: () => boolean,
        [key: string]: any
      },
      private $rootScope: any,
      private $state: any,
      private $http: ng.IHttpService,
      private configuration: any,
      private store: ng.a0.storage.IStoreService,
      private jwtHelper: any,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private ArchiSmallServices: ArchiSmallServices,
      private $sce: ng.ISCEService,
      private $filter: ng.IFilterService,
      private UISelectService: UISelectService,
  ) {
    // $scope.entries = Object.entries;
    $scope.pageHeader = 'Upload Fatture Passive';
    $scope.pageSubHeader = 'Scegli l\'utente per il caricamento delle fatture passive';
    $scope.user = undefined;
    $scope.usersList = [];
    $scope.filtroScadenza = [];
    let anagrafica = [] as IUserT[];
    $scope.dati = [{xml: undefined, metadati: undefined}];
    $rootScope.formsubmitted = false;

    $scope.filterScaduti = () => {
      $scope.usersList = anagrafica.filter(item => {
        const ragSociale = item.company_name.toLowerCase().includes($scope.filtroScadenza[0] && $scope.filtroScadenza[0].toLowerCase() || '');
        const piva = item.piva.toLowerCase().includes($scope.filtroScadenza[1] && $scope.filtroScadenza[1].toLowerCase() || '');
        const codice_fiscale = item.codice_fiscale.toLowerCase().includes($scope.filtroScadenza[3] && $scope.filtroScadenza[3].toLowerCase() || '');
        const email = item.email.toLowerCase().includes($scope.filtroScadenza[2] && $scope.filtroScadenza[2].toLowerCase() || '');
        return ragSociale && piva && codice_fiscale && email;
      });
    };

    $scope.setUser = async (id) => {
      $scope.user = anagrafica.find(item => item._id === id);

    };

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.readFile = (file: File): Promise<string> => {
      const reader = new FileReader();
      return new Promise<string>((resolve, reject) => {
        reader.readAsBinaryString(file);
        reader.onload = (e) => resolve(reader.result as string);
        reader.onerror = (err) => reject(err);
      });
    };

    $scope.canRemove = () => {
      return $scope.dati.length < 2
    }

    $scope.addFile = () => {
      $scope.dati.push({xml: undefined, metadati: undefined});
    }

    $scope.removeFile = (index: number) => {
      $scope.dati.splice(index, 1);

      // console.log($scope.dati);
    }

    $scope.loadFile = async (e, tipo: string, index: number) => {
      const files = e.target.files as FileList;
      // console.log(files);
      const filecont = btoa((await $scope.readFile(files[0])));
      // const ab = new Uint8Array(filecont);
      const caricare = $scope.dati[index] || {xml: undefined, metadati: undefined} as typeof $scope.dati[0];
      if (tipo === 'xml') {
        caricare.xml = {file: filecont, name: files[0].name};
      } else {
        caricare.metadati = {file: filecont, name: files[0].name};
      }
      $scope.dati[index] = caricare;

      // console.log($scope.dati);
      $scope.$apply();
    };

    $scope.getUsersTypeaheadValues = () => {
      ArchiSmallServices.getUsers()
          .then((response) => {

            $scope.originalUsers = JSON.parse(JSON.stringify(response)) as IUser[];

            anagrafica = (JSON.parse(JSON.stringify(response)) as IUser[]).reverse().map(item => {
              return {
                email: item.accountData.email,
                piva: item.organizationData.PIVA,
                codice_fiscale: item.organizationData.fiscalCode,
                company_name: item.organizationData.name ||
                  (item.organizationData.contactPerson.firstname + ' ' + item.organizationData.contactPerson.surname),
                _id: item._id,
              };
            }).sort(({company_name: a}, {company_name: b}) => a.localeCompare(b));
            // response.unshift({email: 'create_all_accounts@archismall.it', piva: 'Tutti utenti',
            //   company_name: 'Tutti utenti', _id: '-'});
            console.log(response);
          }, (error) => {
            $rootScope.alert('error', error);
          });
    };
    $scope.getUsersTypeaheadValues();

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.openConfermaModal = (size) => {

      const dati = (JSON.parse(JSON.stringify($scope.dati)) as typeof $scope.dati).filter(item=>{
        if(item.xml===undefined || item.metadati===undefined)
          return false;
        return true;
      })

      if (dati.length<1) {
        return;
      }

      const user = $scope.originalUsers.find(user => {
        return user._id === $scope.user._id;
      });

      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'uploadFatturePassiveModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return user;
          },
          dati: () => {
            return dati;
          },
          admin:true,
        }
      });

      setTimeout($scope.getUsersTypeaheadValues, 3000);

      $scope.user = undefined;
      $scope.dati = [{xml: undefined, metadati: undefined}];
      $scope.usersList = [];
    };

  }
}

export const UploadFatturePassiveComponent: ng.IComponentOptions = {
  template: require('./upload-fatture-passive.html'),
  controller: UploadFatturePassiveContoller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/upload-fatture-passive/upload-fatture-passive.ts